<template>
  <div>
    <b-card title="Assigned Orders Reports">
      <b-row>
        <b-col
          cols="12"
          lg="6"
          class="my-1 align-items-start"
        >
          <v-select
            v-model="selectedReport"
            :reduce="option => option.key"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            placeholder="Select Required Report"
            :options="filteredOptions"
          />
        </b-col>
      </b-row>
    </b-card>
    <div v-if="selectedReport">
      <report-downloads-table
        :key="selectedReport"
        download-source="assigned-order"
        :queue-report-type="queueReportType"
      />
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ReportDownloadsTable from '@/views/reports/Downloads/ReportDownloadsTable.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    vSelect,
    ReportDownloadsTable,
  },
  data() {
    return {
      selectedReport: '',
      reportOptions: [
        {
          name: 'RECEIVED ORDERS TO ORIGIN WAREHOUSE',
          key: 'received_orders_to_origin_warehouse',
          queueReportType: 'assigned_order_received_orders_to_origin_warehouse',
          permission: 'received-orders-to-origin-warehouse-report',
        },
        {
          name: 'DELIVERY RIDER',
          key: 'delivery_rider',
          queueReportType: 'assigned_order_delivery_rider',
          permission: 'assigned-orders-to-delivery-rider-report',
        },
        {
          name: 'PICKUP RIDER',
          key: 'pickup_rider',
          queueReportType: 'assigned_order_pickup_rider',
          permission: 'assigned-orders-to-pickup-rider-report',
        },
        {
          name: 'DISPATCHED TO DESTINATION WAREHOUSE',
          key: 'dispatched_from_origin_warehouse',
          queueReportType: 'assigned_order_dispatched_from_origin_warehouse',
          permission: 'assigned-orders-to-warehouse-report',
        },
        {
          name: 'RESCHEDULED',
          key: 'rescheduled',
          queueReportType: 'assigned_order_rescheduled',
          permission: 'assigned-orders-rescheduled-report',
        },
        {
          name: 'RETURN TO CLIENT',
          key: 'return_to_client',
          queueReportType: 'assigned_order_return_to_client',
          permission: 'returned-orders-to-merchant-report',
        },
        {
          name: 'RECEIVED AT SORTING WAREHOUSE (FAILED TO DELIVER)',
          key: 'return_to_origin_warehouse',
          queueReportType: 'assigned_order_return_to_origin_warehouse',
          permission: 'returned-orders-to-origin-warehouse-report',
        },
        {
          name: 'RETURNED TO SORTING WAREHOUSE (INVALID DESTINATION)',
          key: 'return_to_origin_warehouse_invalid_destination',
          queueReportType: 'assigned_order_return_to_origin_warehouse_invalid_destination',
          permission: 'returned-orders-to-origin-warehouse-invalid-destination-report',
        },
      ],
    }
  },
  computed: {
    filteredOptions() {
      return this.reportOptions.filter(option => this.hasPermission(option.permission))
    },
    queueReportType() {
      const selected = this.reportOptions.find(option => option.key === this.selectedReport)
      return selected ? selected.queueReportType : ''
    },
  },
  methods: {
    hasPermission(permission) {
      return this.$store.getters.permissions.includes(permission)
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
</style>
